export const APPLICATION_ERROR_TIN_ALREADY_REGISTERED =
  'TIN_ALREADY_REGISTERED';
